<template>
  <div class="select-date">
    <div class="warning info">
      <p>{{ warningText }}</p>
    </div>
    <div class="date-container" v-if="dates.length > 0">
      <h2 class="label">
        {{ $t('labels.selecione-datas') }}
      </h2>
      <div class="input-group">
        <div class="field" v-for="(date, index) in dates" :key="index">
          <b-checkbox
            :native-value="date.checkboxDesc" v-model="checkboxGroup" @input="$emit('enable-button')"
          >
            {{ date.checkboxDesc }}
          </b-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'DateSelect',
  data () {
    return {
      checkboxGroup: []
    }
  },
  props: {
    dates: {
      type: Array,
      default: () => { return [] }
    },
    value: {
      type: String,
      default: ''
    },
    warningText: {
      type: String,
      default: ''
    }
  },
  updated () {
    this.handleData()
  },
  methods: {
    ...mapMutations(['SET_ATESTADO_DADOS', 'DESABILITAR_BOTAO_ENVIAR']),
    handleData () {
      this.SET_ATESTADO_DADOS(this.checkboxGroup)
      this.checkboxGroup.length > 0 ? this.DESABILITAR_BOTAO_ENVIAR(false) : this.DESABILITAR_BOTAO_ENVIAR(true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/stylesheets/base";
@import "~@/assets/stylesheets/forms";
@import "~@/assets/stylesheets/warnings";

.date-container{
  margin-top: 2.5rem;
  .input-group{
    padding-bottom: 1.25rem;
  }
  .field{
    margin: 0
  }
}
.warning {
  max-width: 80%;
}

</style>
